export default "__VITE_ASSET__61f103bf__"